import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: '32px', md: '64px' },
  },
  infoContainer: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    gap: { md: '16px' },
  },
  heading: {
    color: 'text.primary',
    marginTop: 'auto',
  },
  description: {
    color: 'text.primary',
  },
  image: {
    minHeight: '456px',
    width: '100%',
    position: 'absolute',
    top: 0,
    zIndex: -1,
  },
  imageHeading: {},
  featuresWrapper: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'unset',
    },
    flexWrap: { md: 'wrap' },
    gap: '2%',
    rowGap: '24px',
    mt: {
      xs: '16px',
      md: '32px',
    },
  },
  previewsWrapper: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'unset',
    },
    flexWrap: { md: 'wrap' },
    gap: { xs: '48px', md: '24px' },
    mt: {
      xs: '32px',
      md: '64px',
    },
  },
  featureCardStyles: {
    flexBasis: { xs: '100%', sm: '49%' },
    flex: 1,
  },
})

export const stylesImageHeadingVariant = createStyles({
  infoContainer: {
    minHeight: '456px',
    padding: '24px',
    overflow: 'hidden',
    borderRadius: '16px',
    backgroundColor: '#00000033',
  },
  imageHeading: {
    background: '#FFFFFF0D',
    border: '1px solid',
    borderColor: 'border.light',
    borderRadius: '40%',
    color: 'text.primaryDark',
    width: 'max-content',
    padding: '6px 12px',
  },
  heading: {
    color: 'text.primaryDark',
    marginTop: 'auto',
  },
  description: {
    color: 'text.primaryDark',
  },
  image: {
    minHeight: '456px',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: -1,
  },
})
export type StylesClassNames = StylesClasses<typeof styles>

export default styles
